module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxwYXRoIGZpbGw9IiMzNDJENTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQwLjA3MSA5LjkxTDM3LjkzIDcuNzg5IDI0IDIxLjU3NyAxMC4wNzEgNy43OSA3LjkzIDkuOTA5IDIxLjg1NyAyMy43IDcuOTMgMzcuNDg2bDIuMTQyIDIuMTIxTDI0IDI1LjgybDEzLjkyOSAxMy43ODggMi4xNDItMi4xMi0xMy45MjgtMTMuNzlMNDAuMDcgOS45MXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/img-close-icon.svg
// module id = q0G8
// module chunks = 1